/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Order_PendingInputs */

const en_my_payments_order_pending = /** @type {(inputs: My_Payments_Order_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for payment`)
};

const pl_my_payments_order_pending = /** @type {(inputs: My_Payments_Order_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czeka na płatność`)
};

/**
* | output |
* | --- |
* | "Waiting for payment" |
*
* @param {My_Payments_Order_PendingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_order_pending = /** @type {((inputs?: My_Payments_Order_PendingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Order_PendingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_order_pending(inputs)
	return en_my_payments_order_pending(inputs)
});